var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.39 9.001h-.803v-2.25a4.857 4.857 0 00-1.547-3.41 5.012 5.012 0 00-3.541-1.34 5.012 5.012 0 00-3.543 1.34 4.857 4.857 0 00-1.549 3.41V9h-.8a1.581 1.581 0 00-1.118.423A1.533 1.533 0 003 10.5v6c.011.408.187.796.489 1.077.3.281.703.433 1.119.422h11.784c.416.011.818-.141 1.12-.422.3-.282.476-.669.488-1.078V10.5a1.532 1.532 0 00-.489-1.076A1.581 1.581 0 0016.392 9h-.002zm-3.482 0H8.085v-2.25a2.362 2.362 0 01.752-1.595 2.436 2.436 0 011.66-.65c.617 0 1.21.232 1.659.65.448.417.717.988.752 1.594l-.002 2.251z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default ForwardRef;